import React, {Component, ReactElement} from 'react'
import NatLifeNoteRepo from './repository/NatLifeNoteRepo'
import {
    LifeNoteInfo,
    NatGetLifeNoteList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetLifeNoteList'
import {
    ADMINISTORATOR_MODE,
    LIFE_CONVENIENT_BOOK_CATEGORY,
    PREFECTURES_MASTER,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {Messages} from '../../../Messages';
import {HKConstants} from '../../../HKConstants';
import AuthorityChecker from '../../../components/AuthorityChecker';
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea';
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea';
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons';
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate';
import {SortOrder} from '../../../components/shared/SortOrder';
import {SessionStorageHelper} from '../../../SessionStorageHelper';
import {COMMON_CONSTANTS} from '../../../CommonConstants';
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay';
import SortableTableHeader, {
    SortableTableHeaderCell
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader';
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable';
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody';
import {SortDirection} from '@mui/material/TableCell';
import {formatDateTimeForUpdateDate, formatForDateInput} from '../../../formatters/formatDate';
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableFixed,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPSelect from '../../../components/shared/forms/PPSelect'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import {addEmptyData, NoSelectedValue} from '../../../componentHelper/selectHelper'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {Location} from 'react-router-dom'

import {Link, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

const KEY_SEARCH_CONDITION: string = 'adminLifeNoteListPageSearchCondition'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'
const KEY_SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'
const KEY_SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'

interface Props {
    lifeNoteRepo: NatLifeNoteRepo,
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    selectedCategoryId: string
    lifeNoteList: LifeNoteInfo[]
    lifeNotes: LifeNoteInfo[]
    searchResult: SearchResult
    condominiumGroup: NatGetCondominiumGroup
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    selectedCondominiumCd: string | null
    isLoadCompleted: boolean
}

interface LastSearchCondition extends SearchCondition {
    pageNum?: number
}

class NatAdminLifeNoteListPage extends Component<Props & AdminPagePropsSet, States> {

    mode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.mode = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ADMINISTORATOR_MODE)

        const selectedCondominiumCd: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)

        let lastSearchCondition: LastSearchCondition = {}

        const sessionStorageSearchCondition: string | null = window.sessionStorage.getItem(KEY_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            // 前回検索条件が保持されていればデフォルト値として設定する
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        } else {
            // 前回検索条件が保持されていない
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                // 全体モード時は「個別物件向けの情報を抽出する」にチェックなしで表示
                lastSearchCondition.condominiumLifeNoteFlag = VALID_OR_NOT_CHECK.NOT.value
            }
        }

        // 全体モード時＆前回の検索条件が指定されていない場合は、ログインユーザの所属する物件グループを設定
        const loginUserCondominiumGroupId: number | null =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)
        if (this.mode === ADMINISTORATOR_MODE.ALL.value &&
            !lastSearchCondition.condominiumGroupId &&
            loginUserCondominiumGroupId) {
            lastSearchCondition.condominiumGroupId = loginUserCondominiumGroupId

        }

        let defaultSearchCondition: SearchCondition = {}

        if (Object.keys(lastSearchCondition).length) {
            defaultSearchCondition = {
                condominiumCd: lastSearchCondition.condominiumCd,
                condominiumName: lastSearchCondition.condominiumName,
                condominiumGroupId: lastSearchCondition.condominiumGroupId,
                deliveryTargetPrefectureCd: lastSearchCondition.deliveryTargetPrefectureCd,
                deliveryTargetAddress2: lastSearchCondition.deliveryTargetAddress2,
                extractStart: lastSearchCondition.extractStart,
                extractEnd: lastSearchCondition.extractEnd,
                categoryId: lastSearchCondition.categoryId,
                condominiumLifeNoteFlag: lastSearchCondition.condominiumLifeNoteFlag,
            }
        }

        let defaultSearchConditionPage: SearchConditionPageInfo = {
            pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        if (lastSearchCondition.pageNum) {
            defaultSearchConditionPage = {
                pageNum: Number(lastSearchCondition.pageNum),
                page: COMMON_CONSTANTS.FIRST_PAGE,
            }
        }

        let defaultSearchConditionSort: SortOrder[] = [
            new SortOrder('updateDatetime', 'desc'),
            new SortOrder('sortOrder', 'asc'),
        ]
        if (this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value) {
            defaultSearchConditionSort = [
                new SortOrder('sortOrder', 'asc'),
                new SortOrder('updateDatetime', 'desc'),
            ]
        }


        this.state = {
            selectedCategoryId: '',
            lifeNoteList: [],
            lifeNotes: [],
            searchResult: {},
            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            searchCondition: defaultSearchCondition,
            searchConditionPageInfo: defaultSearchConditionPage,
            searchConditionSortInfo: defaultSearchConditionSort,
            selectedCondominiumCd: selectedCondominiumCd,
            isLoadCompleted: false,
        }


        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.onClickRegisterLifeNoteButton = this.onClickRegisterLifeNoteButton.bind(this)
        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangeCategory = this.onChangeCategory.bind(this)
        this.onChangeDeliveryPrefectureCd = this.onChangeDeliveryPrefectureCd.bind(this)
        this.onChangeDeliveryAddress2 = this.onChangeDeliveryAddress2.bind(this)
        this.onChangeExtractStart = this.onChangeExtractStart.bind(this)
        this.onChangeExtractEnd = this.onChangeExtractEnd.bind(this)
        this.onChangeCondominiumMessageFlag = this.onChangeCondominiumMessageFlag.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.handleSortLifeNotes = this.handleSortLifeNotes.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 全体モード時のみ物件グループを取得
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (condominiumGroupResponse && condominiumGroupResponse.details) {
                    this.setState({condominiumGroup: condominiumGroupResponse})
                }
            }
            const searchCondition = {...this.state.searchCondition}
            if (!searchCondition.extractStart && !searchCondition.extractEnd) {
                // 初期状態の抽出範囲に現在日時を設定
                const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                    this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (currentDateTime?.details) {
                    const defaultSearchDate = formatForDateInput(currentDateTime.details.currentDateTime)
                    searchCondition.extractStart = defaultSearchDate
                    searchCondition.extractEnd = defaultSearchDate
                    this.setState({searchCondition: searchCondition})
                }
            }
            // 生活便利帳一覧取得
            await this.searchLifeNotes(
                this.state.searchCondition, this.state.searchConditionPageInfo, this.state.searchConditionSortInfo,
            )
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        // 検索条件を保持
        const lastSearchCondition: LastSearchCondition = {
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            deliveryTargetPrefectureCd: this.state.searchCondition.deliveryTargetPrefectureCd,
            deliveryTargetAddress2: this.state.searchCondition.deliveryTargetAddress2,
            extractStart: this.state.searchCondition.extractStart,
            extractEnd: this.state.searchCondition.extractEnd,
            categoryId: this.state.searchCondition.categoryId,
            condominiumLifeNoteFlag: this.state.searchCondition.condominiumLifeNoteFlag,
            pageNum: this.state.searchConditionPageInfo.pageNum,

        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchConditionPageInfo: SearchConditionPageInfo = {
            pageNum: this.state.searchConditionPageInfo.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        await this.searchLifeNotes(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})

        // 検索条件を保持
        window.sessionStorage.setItem(KEY_SEARCH_CONDITION, JSON.stringify(this.state.searchCondition))

    }

    // 物件検索
    async searchLifeNotes(
        searchCondition?: SearchCondition,
        searchConditionPageInfo?: SearchConditionPageInfo,
        searchConditionSortInfo?: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {

            const searchParams: string[] = []
            if (searchCondition) {
                if (searchCondition.condominiumGroupId) {
                    searchParams.push(`condominiumGroupId=${encodeURIComponent(searchCondition.condominiumGroupId)}`)
                }
                if (searchCondition.condominiumCd) {
                    searchParams.push(`condominiumCd=${encodeURIComponent(searchCondition.condominiumCd)}`)
                }
                if (searchCondition.condominiumName) {
                    searchParams.push(`condominiumName=${encodeURIComponent(searchCondition.condominiumName)}`)
                }
                if (searchCondition.deliveryTargetPrefectureCd) {
                    searchParams.push(`deliveryTargetPrefectureCd=${encodeURIComponent(searchCondition.deliveryTargetPrefectureCd)}`)
                }
                if (searchCondition.deliveryTargetAddress2) {
                    searchParams.push(`deliveryTargetAddress2=${encodeURIComponent(searchCondition.deliveryTargetAddress2)}`)
                }
                if (searchCondition.extractStart) {
                    searchParams.push(`extractStart=${encodeURIComponent(searchCondition.extractStart)}`)
                }
                if (searchCondition.extractEnd) {
                    searchParams.push(`extractEnd=${encodeURIComponent(searchCondition.extractEnd)}`)
                }
                if (searchCondition.categoryId) {
                    searchParams.push(`categoryId=${encodeURIComponent(searchCondition.categoryId)}`)
                }
                if (searchCondition.condominiumLifeNoteFlag) {
                    searchParams.push(`condominiumLifeNoteFlag=${encodeURIComponent(searchCondition.condominiumLifeNoteFlag)}`)
                }
            }
            if (searchConditionPageInfo) {
                if (searchConditionPageInfo.pageNum !== undefined) {
                    searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`)
                }
                if (searchConditionPageInfo.page !== undefined) {
                    searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`)
                }
            }

            if (searchConditionSortInfo) {
                searchConditionSortInfo.forEach((sortInfo, index) => {
                    const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
                    searchParams.push(`sortInfo=${value}`)
                })
            }

            // ソートのサブキーを追加
            const subSortKey: string = encodeURIComponent(`lifeNoteId:asc`)
            searchParams.push(`sortInfo=${subSortKey}`)

            // 生活便利帳一覧取得
            const getLifeNoteResponse: Nullable<NatGetLifeNoteList> =
                await this.props.asyncCallFunction(
                    this.props.lifeNoteRepo.getLifeNoteList.bind(
                        this.props.lifeNoteRepo,
                        searchParams.join('&'),
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getLifeNoteResponse && getLifeNoteResponse.details) {
                this.setState({
                    lifeNotes: getLifeNoteResponse.details.lifeNoteInfo,
                    searchResult: getLifeNoteResponse.details.searchResult,
                })
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }


    onChangeCondominiumGroupId(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumGroupId = Number(event.target.value)
        this.setState({searchCondition: searchCondition})
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumCd = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumName = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    onChangeCategory(event: SelectChangeEvent<unknown>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (event.target.value === NoSelectedValue) {
            searchCondition.categoryId = ''
        } else {
            searchCondition.categoryId = event.target.value as string
        }
        this.setState({searchCondition: searchCondition})
    }

    onChangeDeliveryPrefectureCd(event: SelectChangeEvent<unknown>): void {
        const searchConditions = this.state.searchCondition
        if (event.target.value === NoSelectedValue) {
            searchConditions.deliveryTargetPrefectureCd = ''
        } else {
            const codeMaster = PREFECTURES_MASTER.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                searchConditions.deliveryTargetPrefectureCd = event.target.value as string
            } else {
                searchConditions.deliveryTargetPrefectureCd = ''
            }
        }
        this.setState({searchCondition: searchConditions})
    }

    onChangeDeliveryAddress2(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.deliveryTargetAddress2 = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeExtractStart(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.extractStart = formatForDateInput(date.toString())
        } else {
            searchCondition.extractStart = ''
        }

        this.setState({searchCondition: searchCondition})
    }

    onChangeExtractEnd(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.extractEnd = formatForDateInput(date.toString())
        } else {
            searchCondition.extractEnd = ''
        }

        this.setState({searchCondition: searchCondition})
    }


    onChangeCondominiumMessageFlag(): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (this.state.searchCondition.condominiumLifeNoteFlag === VALID_OR_NOT_CHECK.VALID.value) {
            searchCondition.condominiumLifeNoteFlag = VALID_OR_NOT_CHECK.NOT.value
        } else {
            searchCondition.condominiumLifeNoteFlag = VALID_OR_NOT_CHECK.VALID.value
        }
        this.setState({searchCondition: searchCondition})
    }

    onClickRegisterLifeNoteButton(): void {
        this.props.navigate('/admin/lifeNoteRegister')
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumGroupId = condomoniumGroupId
        this.setState({searchCondition: searchCondition})
    }

    getCategoryLabel(categoryId: string): string {
        const lifeNoteCategoryLabel = LIFE_CONVENIENT_BOOK_CATEGORY.codeToEnumConstants(categoryId)
        if (lifeNoteCategoryLabel) {
            return lifeNoteCategoryLabel.label
        } else {
            return ''
        }
    }

    getFormatForDateInputAllowNull(publishEndDate: string): string {
        if (publishEndDate !== null) {
            return formatForDateInput(publishEndDate)
        } else {
            return publishEndDate
        }
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            return PREFECTURES_MASTER.codeToEnumConstants(prefectureCd).label
        } else {
            return ''
        }
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.lifeNotes.length === 0) {
            if (!Object.keys(this.state.searchCondition).length) {
                return {noResultMessage: Messages.IOPCC0015.toString('生活便利帳')}
            }
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.searchResult.total ? this.state.searchResult.total : 0,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.searchLifeNotes(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: LastSearchCondition = {
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            extractStart: this.state.searchCondition.extractStart,
            extractEnd: this.state.searchCondition.extractEnd,
            categoryId: this.state.searchCondition.categoryId,
            condominiumLifeNoteFlag: this.state.searchCondition.condominiumLifeNoteFlag,
            pageNum: Number(event.target.value),

        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.searchLifeNotes(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async handleSortLifeNotes(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.searchLifeNotes(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    renderLifeNoteTable(lifeNotes: LifeNoteInfo[]): Nullable<ReactElement> {
        if (lifeNotes.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {id: 'title', label: 'タイトル'},
            {id: 'category', label: 'カテゴリ'},
            {
                id: 'sortOrder',
                label: '並び順',
                sortable: true,
                direction: this.getSortDirection('sortOrder'),
            },
            {id: 'publishStartDate', label: '掲載開始'},
            {id: 'publishEndDate', label: '掲載終了'},
        ]
        if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
            headers.push({id: 'condominiumOrGroup', label: '物件グループ/物件名'})
            headers.push({id: 'deliveryTargetArea', label: '指定地域'})
        }
        headers.push({
            id: 'updateDatetime',
            label: '更新日時',
            sortable: true,
            direction: this.getSortDirection('updateDatetime'),
        })

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.searchResult.total ? this.state.searchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSortLifeNotes}
                />
                <SortablePaginationTableBody>
                    {this.state.lifeNotes.map(
                        lifeNote => this.renderLifeNoteRecord(lifeNote),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    renderLifeNoteRecord(lifeNote: LifeNoteInfo): ReactElement {
        const lifeNoteUrl: string = `/admin/lifeNote/${lifeNote.lifeNoteId}`
        return (
            <TableRow key={lifeNote.lifeNoteId}>
                <TableCellWordBreakAll align={'center'}>
                    <Link href={lifeNoteUrl} underline="hover">{lifeNote.title}</Link></TableCellWordBreakAll>
                <TableCell align={'center'}>{this.getCategoryLabel(lifeNote.categoryId)}</TableCell>
                <TableCell align={'center'}>{lifeNote.sortOrder}</TableCell>
                <TableCell align={'center'}>{formatForDateInput(lifeNote.publishStartDate)}</TableCell>
                <TableCell align={'center'}>{this.getFormatForDateInputAllowNull(lifeNote.publishEndDate)}</TableCell>
                {this.mode === ADMINISTORATOR_MODE.ALL.value && lifeNote.condominiumName &&
                    <TableCellWordBreakAll align={'center'}>{lifeNote.condominiumName}</TableCellWordBreakAll>
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value && !lifeNote.condominiumName &&
                    <TableCellWordBreakAll align={'center'}>{lifeNote.condominiumGroupName}</TableCellWordBreakAll>
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                    <TableCellWordBreakAll align={'center'}>
                        {this.getPrefectureName(lifeNote.deliveryTargetPrefectureCd)}
                        {lifeNote.deliveryTargetAddress2}
                    </TableCellWordBreakAll>
                }
                <TableCell align={'center'}>{formatDateTimeForUpdateDate(lifeNote.updateDatetime)}</TableCell>
            </TableRow>
        )
    }

    renderConditionTableRowForAll(): ReactElement {
        return (
            <>
                <ConditionTableFixed>
                    <colgroup>
                        <col width={'10%'}/>
                        <col width={'15%'}/>
                        <col width={'25%'}/>
                        <col width={'10%'}/>
                        <col width={'35%'}/>
                    </colgroup>
                    <ConditionTableBody>
                        <ConditionTableRow>
                            <ConditionCategoryCell rowSpan={7}>物件情報</ConditionCategoryCell>
                            <ConditionColumNameCell>物件グループを選択</ConditionColumNameCell>
                            {
                                this.state.condominiumGroup &&
                                this.state.condominiumGroup.details &&
                                <ConditionInputCell colSpan={3}>
                                    <NatCondominiumGroupSelectComponent
                                        condominiumGroup={this.state.condominiumGroup.details}
                                        defaultValue={Number(this.state.searchCondition.condominiumGroupId)}
                                        onChangeSelectedCondominiumGroupId={this.onChangeSelectedCondominiumGroupId}
                                        requiredFlag={true}
                                        eventKeys={['condominiumGroupId']}
                                        eventEmitter={this.props.eventEmitter}
                                        autoFocus={true}
                                    >
                                    </NatCondominiumGroupSelectComponent>
                                </ConditionInputCell>
                            }
                            <ConditionButtonCell></ConditionButtonCell>
                        </ConditionTableRow>
                        <ConditionTableRow>
                            <ConditionColumNameCell>物件コード</ConditionColumNameCell>
                            <ConditionInputCell colSpan={3}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 6,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumCd}
                                    defaultValue={this.state.searchCondition.condominiumCd}
                                />
                            </ConditionInputCell>
                        </ConditionTableRow>
                        <ConditionTableRow>
                            <ConditionColumNameCell>物件名</ConditionColumNameCell>
                            <ConditionInputCell colSpan={3}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumName}
                                    defaultValue={this.state.searchCondition.condominiumName}
                                />
                            </ConditionInputCell>
                            <ConditionButtonCell></ConditionButtonCell>
                        </ConditionTableRow>
                        <ConditionTableRow>
                            <ConditionColumNameCell>指定地域</ConditionColumNameCell>
                            <ConditionInputCell>
                                <PPSelect
                                    data={addEmptyData(PREFECTURES_MASTER.values(), '都道府県を選択してください')}
                                    onChange={this.onChangeDeliveryPrefectureCd}
                                    eventKeys={['deliveryTargetPrefectureCd']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.searchCondition.deliveryTargetPrefectureCd}
                                />
                            </ConditionInputCell>
                            <ConditionColumNameCell>市区町村</ConditionColumNameCell>
                            <ConditionInputCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeDeliveryAddress2}
                                    defaultValue={this.state.searchCondition.deliveryTargetAddress2}
                                />
                            </ConditionInputCell>
                        </ConditionTableRow>
                        <ConditionTableRow>
                            <ConditionColumNameCell>抽出範囲</ConditionColumNameCell>
                            <ConditionInputCell colSpan={3}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                            <PPDatePicker
                                                onChangeDate={this.onChangeExtractStart}
                                                value={(this.state.searchCondition.extractStart &&
                                                    this.state.searchCondition.extractStart !== '') ?
                                                    new Date(this.state.searchCondition.extractStart) : null
                                                }
                                                maxDate={(this.state.searchCondition.extractEnd &&
                                                    this.state.searchCondition.extractEnd !== '') ?
                                                    new Date(this.state.searchCondition.extractEnd) : undefined
                                                }
                                            />
                                        </FlexBasis>
                                        <TermTxt>から</TermTxt>
                                    </TermWrapper>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                            <PPDatePicker
                                                onChangeDate={this.onChangeExtractEnd}
                                                value={(this.state.searchCondition.extractEnd &&
                                                    this.state.searchCondition.extractEnd !== '') ?
                                                    new Date(this.state.searchCondition.extractEnd) : null
                                                }
                                                minDate={(this.state.searchCondition.extractStart &&
                                                    this.state.searchCondition.extractStart !== '') ?
                                                    new Date(this.state.searchCondition.extractStart) : undefined
                                                }
                                            />
                                        </FlexBasis>
                                        <TermTxt>の間</TermTxt>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </ConditionInputCell>
                        </ConditionTableRow>
                        <ConditionTableRow>
                            <ConditionColumNameCell>カテゴリを選択</ConditionColumNameCell>
                            <ConditionInputCell colSpan={1}>
                                <PPSelect
                                    fullWidth
                                    data={addEmptyData(LIFE_CONVENIENT_BOOK_CATEGORY.values(), '全てのカテゴリ')}
                                    onChange={this.onChangeCategory}
                                    defaultValue={this.state.searchCondition.categoryId}
                                />
                            </ConditionInputCell>
                        </ConditionTableRow>
                        <ConditionTableRow>
                            <ConditionColumNameCell></ConditionColumNameCell>
                            <ConditionInputCell colSpan={2}>
                                <PPCheckboxGroup
                                    data={[{
                                        label: '個別物件向けの情報を抽出する',
                                        checked:
                                            this.state.searchCondition.condominiumLifeNoteFlag ===
                                            VALID_OR_NOT_CHECK.VALID.value,
                                    }]}
                                    onChange={this.onChangeCondominiumMessageFlag}
                                />
                            </ConditionInputCell>
                            <ConditionButtonCell>
                                <AdminDefaultMediumButton
                                    onClick={this.onClickSearchButton}>
                                    生活便利帳を検索する
                                </AdminDefaultMediumButton>
                            </ConditionButtonCell>
                        </ConditionTableRow>
                    </ConditionTableBody>
                </ConditionTableFixed>
            </>
        )
    }

    renderConditionTableRowForSelectedCondominium(): ReactElement {
        return (
            <>
                <ConditionTableRow>
                    <ConditionCategoryCell rowSpan={2}>生活便利帳情報</ConditionCategoryCell>
                    <ConditionColumNameCell>抽出範囲</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <LeftRowFlexContainer>
                            <TermWrapper>
                                <FlexBasis>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeExtractStart}
                                        value={(this.state.searchCondition.extractStart &&
                                            this.state.searchCondition.extractStart !== '') ?
                                            new Date(this.state.searchCondition.extractStart) : null
                                        }
                                        maxDate={(this.state.searchCondition.extractEnd &&
                                            this.state.searchCondition.extractEnd !== '') ?
                                            new Date(this.state.searchCondition.extractEnd) : undefined
                                        }
                                        autoFocus={(this.mode === ADMINISTORATOR_MODE.ALL.value) ? false : true}
                                    />
                                </FlexBasis>
                                <TermTxt>から</TermTxt>
                            </TermWrapper>
                            <TermWrapper>
                                <FlexBasis>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeExtractEnd}
                                        value={(this.state.searchCondition.extractEnd &&
                                            this.state.searchCondition.extractEnd !== '') ?
                                            new Date(this.state.searchCondition.extractEnd) : null
                                        }
                                        minDate={(this.state.searchCondition.extractStart &&
                                            this.state.searchCondition.extractStart !== '') ?
                                            new Date(this.state.searchCondition.extractStart) : undefined
                                        }
                                    />
                                </FlexBasis>
                                <TermTxt>の間</TermTxt>
                            </TermWrapper>
                        </LeftRowFlexContainer>
                    </ConditionInputCell>
                    <ConditionButtonCell></ConditionButtonCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionColumNameCell>カテゴリを選択</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <PPSelect
                            fullWidth
                            data={addEmptyData(LIFE_CONVENIENT_BOOK_CATEGORY.values(), '全てのカテゴリ')}
                            onChange={this.onChangeCategory}
                            defaultValue={this.state.searchCondition.categoryId}
                        />
                    </ConditionInputCell>
                    <ConditionButtonCell>
                        <AdminDefaultMediumButton
                            onClick={this.onClickSearchButton}>
                            生活便利帳を検索する
                        </AdminDefaultMediumButton>
                    </ConditionButtonCell>
                </ConditionTableRow>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}
                >
                    <ConditionTable>
                        <ConditionTableBody>
                            {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                                this.renderConditionTableRowForAll()
                            }
                            {this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value &&
                                this.renderConditionTableRowForSelectedCondominium()
                            }
                        </ConditionTableBody>
                    </ConditionTable>
                </ListSearchFormArea>
                <SearchPageActionArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_LIFE_NOTE_MANAGEMENT}>
                        <AdminDefaultMediumButton onClick={this.onClickRegisterLifeNoteButton}>
                            新規
                        </AdminDefaultMediumButton>
                    </AuthorityChecker>
                </SearchPageActionArea>
                <PageMainArea>
                    {this.renderLifeNoteTable(this.state.lifeNotes)}
                </PageMainArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminLifeNoteListPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`
